import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as appActions from "../../../store/actions/app";
import * as claimsActions from "../../../store/actions/claims";
import { Table } from "react-bootstrap";
import styles from "./ClaimsList.module.css";

function ClaimsList({ claims }) {
  const history = useHistory();
  const dispatch = useDispatch();

    const handleRowClick = (claim) => {
        if(!isNaN(claim.claimNumber) && claim.claimStatus !== "Submitted") {
      dispatch(appActions.setLoading(true));
            history.push(`/view/claim/${claim.claimNumber}`);
    }
  };

  const handleLinkClick = (url) => {
    dispatch(claimsActions.navigateClaimsRemarks(url));
  };

  return (
    <div className={styles.container}>
      <Table striped borderless hover>
        <thead>
          <tr>
            <th>Claim Number</th>
            <th>Loss Date</th>
            <th>Claimant Name</th>
            <th>Policy Number</th>
            <th>Loss Type</th>
            <th>Claim Status</th>
            <th>Evaluation</th>
          </tr>
        </thead>
        <tbody>
          {claims.map((claim, index) => {
            return (
              <tr key={index}>
                                <td className={claim.claimStatus === "Submitted" ? ' ' : styles.row} onClick={() => handleRowClick(claim)}> {claim.claimStatus === "Submitted" ? (
                    <strong>{claim.claimNumber}</strong>
                  ) : (
                    <button
                      className={styles.rowButton}
                      onClick={() =>
                        handleRowClick(claim)
                      }
                    >
                      <strong>{claim.claimNumber}</strong>
                    </button>
                  )}</td>
                                <td className={claim.claimStatus === "Submitted" ? ' ' : styles.row} onClick={() => handleRowClick(claim)}>{claim.lossDate}</td>
                                <td className={claim.claimStatus === "Submitted" ? ' ' : styles.row} onClick={() => handleRowClick(claim)}>{claim.claimantName}</td>
                                <td className={claim.claimStatus === "Submitted" ? ' ' : styles.row} onClick={() => handleRowClick(claim)}>{claim.policyNumber}</td>
                                <td className={claim.claimStatus === "Submitted" ? ' ' : styles.row} onClick={() => handleRowClick(claim)}>{claim.lossType}</td>
                                <td className={claim.claimStatus === "Submitted" ? ' ' : styles.row} onClick={() => handleRowClick(claim)}>{claim.claimStatus}</td>
                <td>
                  {claim.evaluation !== "" && (
                    // eslint-disable-next-line react/jsx-no-target-blank
                    <button
                      className={styles.viewLink}
                      onClick={() => {
                        handleLinkClick(claim.evaluation);
                      }}
                    >
                      View
                    </button>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
}

export default ClaimsList;
